export const fieldSize = Object.freeze({
  crewCodeLength: 5,
  imeiLength: 15,
});
